<template>
  <div>
    <el-row>
      <el-col :xs="24" :md="11">
        <vue-select
          id="brand-select"
          style="width: 100%; font-size: var(--font-primary);"
          :placeholder="$t('Seçin')"
          filterable
          :value="brandId"
          @input="inputBrand"
          :clearable="true"
          :disabled="disabled"
          :options="brands"
          :label="$t('name')"
          :reduce="brand => brand.id"
          @search:focus="getBrand"
        >
          <template #option="{ name }">
            <span>{{ name }}</span>
          </template>
        </vue-select>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :xs="24" :md="11">
        <vue-select
          id="model-select"
          style="width: 100%; font-size: var(--font-primary);"
          :placeholder="$t('Seçin')"
          filterable
          :value="modelId"
          @input="inputModel"
          :clearable="true"
          :disabled="disabled || !brandId"
          :options="models"
          :label="$t('name')"
          :reduce="model => model.id"
        >
          <template #option="{ name }">
            <span>{{ name }}</span>
          </template>
        </vue-select>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { brandapi, modelapi } from "../../services/sales";

export default {
  name: "BrandModel",
  props: {
    disabled: Boolean,
    brand: Number,
    model: Number,
    brandName: String,
    modelName: String,
    customBrandModel: String
  },
  data() {
    return {
      brands: [],
      models: [],
      brandId: null,
      modelId: null,
      loading: false,
      isCustomParsing: false,
      isManualChange: false,
      lastManualChange: 0
    };
  },
  watch: {
    brand(newVal) {
      if (Date.now() - this.lastManualChange < 500) {
        return;
      }
      this.brandId = newVal;
      if (newVal) {
        this.getModel();
      }
    },
    model(newVal) {
      if (Date.now() - this.lastManualChange < 500) {
        return;
      }
      this.modelId = newVal;
    },
    brandName(newVal) {
      if (this.isManualChange || this.brandId) return;
      
      if (newVal && this.brands.length > 0) {
        const foundBrand = this.findBrandByName(newVal);
        if (foundBrand) {
          this.brandId = foundBrand.id;
          this.$emit('change', { brandId: this.brandId, modelId: this.modelId });
        }
      }
    },
    modelName(newVal) {
      if (this.isManualChange || this.modelId) return;
      
      if (newVal && this.models.length > 0) {
        const foundModel = this.findModelByName(newVal);
        if (foundModel) {
          this.modelId = foundModel.id;
          this.$emit('change', { brandId: this.brandId, modelId: this.modelId });
        }
      }
    },
    customBrandModel(newVal) {
      if (this.isManualChange || this.brandId || this.modelId) return;
      
      if (newVal) {
        this.parseCustomBrandModel(newVal);
      }
    }
  },
  methods: {
    normalize(str) {
      return (str || "").toString().toLowerCase().trim();
    },
    findBrandByName(name) {
      return this.brands.find(b => 
        this.normalize(b.name) === this.normalize(name)
      );
    },
    findModelByName(name) {
      return this.models.find(m => 
        this.normalize(m.name) === this.normalize(name)
      );
    },
      inputBrand(e) {
    this.isManualChange = true;
    this.lastManualChange = Date.now();

    this.brandId = e;
    this.modelId = null;
    this.models = [];

    const selectedBrand = this.brands.find(b => b.id === this.brandId);
    const brandName = selectedBrand ? selectedBrand.name : null;

    this.$emit('change', {
      brandId: this.brandId,
      brandName: brandName,
      modelId: this.modelId,
      modelName: null
    });

    if (e) {
      this.getModel();
    }

    setTimeout(() => {
      this.isManualChange = false;
    }, 1000);
  },

  inputModel(e) {
    this.isManualChange = true;
    this.lastManualChange = Date.now();

    this.modelId = e;

    const selectedModel = this.models.find(m => m.id === this.modelId);
    const modelName = selectedModel ? selectedModel.name : null;

    this.$emit('change', {
      brandId: this.brandId,
      brandName: this.findBrandById(this.brandId)?.name, 
      modelId: this.modelId,
      modelName: modelName
    });

    setTimeout(() => {
      this.isManualChange = false;
    }, 1000);
  },

  findBrandById(id) {
    return this.brands.find(b => b.id === id);
  },
    getBrand() {
      if (this.brands.length > 0) return;
      
      this.loading = true;
      brandapi().then(response => {
        this.brands = response.data || [];
        
        if (!this.isManualChange && this.brandName && !this.brandId) {
          const foundBrand = this.findBrandByName(this.brandName);
          if (foundBrand) {
            this.brandId = foundBrand.id;
            this.$emit('change', { brandId: this.brandId, modelId: this.modelId });
            this.getModel();
          }
        }
        
        if (!this.isManualChange && this.customBrandModel && !this.brandId) {
          this.parseCustomBrandModel(this.customBrandModel);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    getModel() {
      if (!this.brandId) {
        this.models = [];
        return;
      }
      
      this.loading = true;
      modelapi(this.brandId).then(response => {
        this.models = response.data || [];
        
        if (!this.isManualChange && this.modelName && !this.modelId) {
          const foundModel = this.findModelByName(this.modelName);
          if (foundModel) {
            this.modelId = foundModel.id;
            this.$emit('change', { brandId: this.brandId, modelId: this.modelId });
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    reset() {
      this.brandId = null;
      this.modelId = null;
      this.models = [];
      this.isManualChange = false;
      this.lastManualChange = 0;
      this.$emit('change', { brandId: null, modelId: null });
    },
    async parseCustomBrandModel(customValue) {
      if (!customValue || this.isCustomParsing || this.isManualChange) return;

      this.isCustomParsing = true;
      const parts = customValue.split(' ');

      for (let i = 1; i <= Math.min(3, parts.length); i++) {
        const possibleBrand = parts.slice(0, i).join(' ');
        const foundBrand = this.findBrandByName(possibleBrand);

        if (foundBrand) {
          this.brandId = foundBrand.id;

          await this.getModel();

          const possibleModel = parts.slice(i).join(' ');
          const foundModel = this.findModelByName(possibleModel);

          if (foundModel) {
            this.modelId = foundModel.id;
            this.$emit('change', {
              brandId: this.brandId,
              modelId: this.modelId,
            });
          }
          break;
        }
      }
      this.isCustomParsing = false;
    }
  },
  mounted() {
    this.brandId = this.brand;
    this.modelId = this.model;
    
    this.getBrand();
    if (this.brandId) {
      this.getModel();
    }
    
    if (!this.isManualChange && this.customBrandModel && !this.brandId && !this.modelId) {
      this.parseCustomBrandModel(this.customBrandModel);
    }
  }
};
</script>

<style>
#brand-select .vs__dropdown-toggle,
#model-select .vs__dropdown-toggle,
#brand-select .vs__dropdown-menu .vs__option,
#model-select .vs__dropdown-menu .vs__option {
  font-size: var(--font-primary) !important;
}

.vs__clear {
  display: none;
}
</style>